// eslint-disable-next-line import/no-unresolved
import { set } from '@/utils/vuex';

const mutations = {
  metricTabsWithMetrics: set('metricTabsWithMetrics'),
};
export default mutations;
